const focusableElementsSelector: string = 'a, button, input, textarea, select, iframe';

export function focusOnFirstElementInContainer(containerElement: HTMLElement): void {
  const firstFocusableElement: HTMLElement = containerElement.querySelector(focusableElementsSelector);
  firstFocusableElement?.focus();
}